<template>
  <section>
    <div class="no-print">
      <b-row>
        <b-col>
          <b-form-group class="form-group">
            <label for="">Período</label>
            <Periods @select="handlePeriod" :monthSelected="monthSelected" />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group class="form-group">
            <label for="">Situação do agendamento</label>
            <CheckBoxSelect
              label="Selecionar situação"
              placeholder="Selecionar situação"
              :value="filter.status"
              :options="situations"
              trackBy="value"
              optionLabel="label"
              @onChange="setSituationFilter"
            />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="health_plan">
            <label for="health_plan" id="input-title">Convênio</label>
            <v-autocomplete
              placeholder="Todos os convênios"
              :options="healthPlans"
              v-model="filter.healthPlan"
            />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group>
            <label for="professional">Executante</label>
            <multiselect
              class="with-border"
              :options="professionals"
              :value="professional"
              label="label"
              @search-change="getProfessionalsAuditDebounce"
              @select="selectProfessional"
              :show-labels="false"
              id="professional"
              placeholder="Selecionar"
            >
              <template slot="caret">
                <div class="chevron">
                  <ChevronDown />
                </div>
              </template>
              <template slot="noOptions">
                Digite para pesquisar um profissional
              </template>
              <template slot="noResult"> Nenhum resultado </template>
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          <b-form-group>
            <label for="patient">Paciente</label>
            <multiselect
              ref="patient-multiselect"
              class="with-border"
              :options="patients"
              v-model="patient"
              label="name"
              track-by="value"
              @search-change="searchPatientsDebounce"
              @select="selectPatient"
              allowEmpty
              :internal-search="false"
              :option-height="40"
              :showLabels="false"
              :showNoResults="true"
              :close-on-select="true"
              id="patient"
              placeholder="Digite para pesquisar paciente"
            >
              <template slot="option" slot-scope="{ option }">
                {{ option.name }}
                <p class="aditional-patient-info">
                  <span>CPF: </span>{{ option.cpf || '-' }}
                </p>
              </template>
              <template slot="caret">
                <div class="chevron">
                  <ChevronDown class="icon" v-if="!patient && !loading" />
                  <b-spinner
                    v-else-if="loading"
                    small
                    type="grow"
                    variant="primary"
                  ></b-spinner>
                  <Close
                    class="clear-button"
                    v-else
                    @click.stop="selectPatient(null)"
                  />
                </div>
              </template>
              <template slot="noOptions">
                Digite para pesquisar um paciente
              </template>
              <template slot="noResult"> Nenhum resultado </template>
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}
              </template>
            </multiselect>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group>
            <label for="item">Item</label>
            <multiselect
              class="with-border"
              :options="items"
              v-model="item"
              label="label"
              track-by="value"
              @search-change="searchItemsDebounce"
              @select="selectItem"
              @remove="selectItem"
              id="item"
              :show-labels="false"
              placeholder="Digite para pesquisar um item"
            >
              <template slot="caret">
                <div class="chevron">
                  <ChevronDown class="icon" v-if="!item && !loading" />
                  <b-spinner
                    v-else-if="loading"
                    small
                    type="grow"
                    variant="primary"
                  ></b-spinner>
                  <Close
                    class="clear-button"
                    v-else
                    @click.stop="selectItem(null)"
                  />
                </div>
              </template>
              <template slot="option" slot-scope="{ option }">
                <span class="item-label"
                  >{{ ITEM.parseTypeToLabel(option.type) }} |
                </span>
                <span v-if="option.code" class="code"
                  >{{ option.code }} -
                </span>
                <span v-if="option.name.length < 40" class="item-label">
                  {{ option.name }}
                </span>
                <span
                  v-else
                  class="item-label"
                  v-b-tooltip.hover
                  :title="option.name"
                >
                  {{ option.name.substring(0, 40) }} ...
                </span>
              </template>
              <template slot="noOptions">
                Digite para pesquisar um item
              </template>
              <template slot="noResult"> Nenhum resultado </template>
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </section>
</template>
<script>
import { getCurrentClinic } from '@/utils/localStorageManager'
import itemsApi from '@/modules/items/api'
import debounce from 'lodash/debounce'
import * as ITEM from '@/modules/items/utils/constants'
export default {
  components: {
    'v-autocomplete': () => import('@/components/Autocomplete'),
    Periods: () => import('@/components/General/Periods'),
    ChevronDown: () => import('@/assets/icons/chevron-down.svg'),
    CheckBoxSelect: () => import('@/components/CheckboxSelect'),
    Close: () => import('@/assets/icons/close.svg')
  },
  props: {
    loading: Boolean
  },
  data() {
    return {
      ITEM,
      clinic: getCurrentClinic(),
      query: '',
      langDatePicker: {
        formatLocale: {
          weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
        }
      },
      filter: {
        healthPlan: null,
        professional: null,
        start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        status: this.getSituationOptions(),
        patient: null,
        item: [],
        itemType: null,
        order: 'desc'
      },
      daySelected: false,
      healthPlans: [],
      professionals: [],
      patients: [],
      items: [],
      patient: null,
      item: null,
      monthSelected: true,
      professional: null,
      situations: this.getSituationOptions()
    }
  },
  created() {
    this.getProfessionalsAuditDebounce = debounce(
      this.getProfessionalsAudit,
      500
    )
    this.searchPatientsDebounce = debounce(this.searchPatients, 500)
    this.searchItemsDebounce = debounce(this.searchItems, 500)
  },
  mounted() {
    this.getClinicHealthPlans()
  },
  methods: {
    handlePeriod(value) {
      this.filter.start = value.start
      this.filter.end = value.end
    },
    async getClinicHealthPlans() {
      try {
        const { data } = await this.api.getAllClinicHealthPlans(this.clinic.id)

        this.healthPlans = data
          .map(clinicHealthPlan => ({
            label: clinicHealthPlan?.health_plan?.fantasy_name,
            value: clinicHealthPlan?.health_plan?.id
          }))
          .sort((a, b) => {
            if (a.label < b.label) return -1
            else return 1
          })
      } catch (error) {
        console.error(error)
      }
    },
    selectProfessional(professional) {
      this.professional = professional
      this.filter.professional = professional.value
      if (!professional.value) {
        this.filters.professional = null
      }
    },
    selectPatient(patient) {
      this.patient = patient
      this.filter.patient = patient?.value
      this.$refs['patient-multiselect'].$refs.search.blur()
    },
    selectItem(item) {
      if (!item) {
        this.filter.item = null
        this.item = null
        this.$refs['item-multiselect'].$refs.search.blur()
        return
      }
      this.filter.item = this.item.value
    },
    async getProfessionalsAudit(query) {
      if (query.length > 2) {
        try {
          const response = await this.api.getProfessionals(
            null,
            this.clinic.id,
            query
          )
          this.professionals = response.data.data.map(professional => {
            return {
              label: professional.name,
              value: professional.id
            }
          })
        } catch (error) {
          this.$toast.error(error.message)
        }
      }
    },

    async searchPatients(query) {
      if (query.length > 2) {
        try {
          const response = await this.api.searchPatients(this.clinic.id, query)
          this.patients = response.data.map(patient => {
            return {
              name: patient.name,
              value: patient.id,
              cpf: patient.cpf
            }
          })
        } catch (error) {
          this.$toast.error(error.message)
        }
      }
    },

    async searchItems(query) {
      if (query.length > 2) {
        try {
          const response = await itemsApi.searchItems(this.clinic.id, query)
          this.items = response.data.map(item => {
            return {
              label: item.name,
              value: item.id,
              name: item.name,
              type: item.type,
              code: item.code
            }
          })
        } catch (error) {
          this.$toast.error(error.message)
        }
      }
    },
    getSituationOptions() {
      return [
        { label: 'Todos', value: null },
        { label: 'Sem situação', value: 'SCHEDULED' },
        { label: 'Compareceu', value: 'ATTEND' },
        { label: 'Atendimeno finalizado', value: 'FINISHED' },
        { label: 'Confirmado', value: 'CONFIRMED' },
        { label: 'Confirmado pelo paciente', value: 'CONFIRMED_BY_PATIENT' },
        { label: 'Faltou', value: 'MISSED' },
        { label: 'Cancelado', value: 'CANCELLED' },
        { label: 'Cancelado pelo paciente', value: 'CANCELLED_BY_PATIENT' },
        { label: 'Aguardando atendimento', value: 'WAITING' },
        { label: 'Em atendimento médico', value: 'HAPPENING' },
        { label: 'Em exames', value: 'EXAMINATING' },
        { label: 'Dilatando', value: 'DILATING' },
        { label: 'Pré-consulta finalizada', value: 'PRE_FINISHED' },
        { label: 'Em pré-consulta', value: 'IN_PRE_CONSULTATION' },
        { label: 'Finalizado', value: 'FINISHED' }
      ]
    },
    setSituationFilter(value) {
      this.filter.status = value
    }
  },
  watch: {
    filter: {
      handler() {
        this.$emit('changeFilter', this.filter)
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-loading-class {
  position: absolute;
  top: 3px !important;
  right: 12px !important;
  z-index: 50;
  transform: scale(-0.5) !important;
}

.icon {
  width: 20px;
  height: 20px;
}

.chevron {
  z-index: 10;

  &.icon {
    stroke: var(--neutral-500);
  }
  .clear-button {
    fill: var(--neutral-500) !important;
    stroke: none !important;
  }
}


.input-wrapper {
  position: relative;
}

.input-wrapper .icon {
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.input-wrapper .form-control {
  padding-left: 35px;
}

.aditional-patient-info {
  font-size: 12px;
  font-style: italic;
  color: #0b30b2;

  span {
    font-weight: 600;
    margin-left: 5px;
  }
}
.code {
  font-size: 0.8rem;
  color: var(--blue-500);
}
.item-label {
  font-size: 0.8rem;
  font-weight: 400;
  color: var(--dark-blue);
}
</style>
